// extracted by mini-css-extract-plugin
export default {"tabPanel":"oSCgMYK3SHx7eNn3dxF049Kjl0PMvYVOPf7Jd0vMk-k="};